import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBug } from "@fortawesome/free-solid-svg-icons/faBug";
import { useScreenSize } from "hooks";

function ScreenSizeDebugger() {
	const { width, size } = useScreenSize();

	const [open, setOpen] = useState(false);
	return (
		<div className="debugger">
			<FontAwesomeIcon icon={faBug} className="w-20px ml-2 pointer" onClick={() => setOpen((open) => !open)} />

			{open && (
				<>
					<div className=" d-block">
						SCREEN SIZE <b>{size}</b> {width}px
					</div>
					<div>APP_ENV {process.env.APP_ENV}</div>
					<div>NODE_ENV {process.env.NODE_ENV}</div>
					<div>API_URL {process.env.API_URL}</div>
					<div>REVALIDATE_TIMER {process.env.REVALIDATE_TIMER}</div>
					<div>SHOPIFY_API_URL {process.env.SHOPIFY_API_URL}</div>
				</>
			)}
			<style jsx>{`
				.debugger {
					background: white;
					box-shadow: 3px 3px 13px 0px black;
					z-index: 1000001;
					position: fixed;
					left: 1em;
				}
			`}</style>
		</div>
	);
}

export default ScreenSizeDebugger;
